export const REPORTING_EDIT_SCOPE = 'reporting-edit';
export const REPORT_INSIGHTS_ACCESS_SCOPE = 'report-insights-access';
export const SERVICE_JOURNEY_ANALYTICS_READ_SCOPE = 'service-journey-analytics-read';
export const getDoesUserHaveReportEditAccess = scopes => {
  return scopes.includes(REPORTING_EDIT_SCOPE);
};